import Vue from 'vue';



export const formatMoney = val => {
    let rst = parseFloat(val)

    if(!isNaN(rst)){
        rst = rst.toFixed(2)

        return rst
    }else{
        return val
    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js